const changeViewDropdown = {
  company: {
    body: 'Möchten Sie das Unternehmen wirklich ändern?',
  },
  site: {
    body: 'Möchten Sie den Bereich wirklich ändern?',
  },
};

export default changeViewDropdown;
